import React, { createContext, useContext, useState } from 'react'

import { useFetchFilters } from '../api/apiHooks'
import { GenerateMentor } from '../components/GenerateMentor'

interface GenerateMentorContextType {
  isOpen: boolean
  openPopup: () => void
  closePopup: () => void
}

const WithGenerateMentorContext = createContext<
  GenerateMentorContextType | undefined
>(undefined)

interface IWithGenerateMentorProps {
  children: React.ReactNode | React.ReactNode[]
}

const WithGenerateMentor: React.FC<IWithGenerateMentorProps> = ({ children }) => {
  const { data: allFilters } = useFetchFilters()

  const [isOpen, setIsOpen] = useState(false)
  const [shouldRender, setShouldRender] = useState(false)
  const openPopup = () => {
    setIsOpen(true)
    setShouldRender(true)
  }
  const closePopup = () => {
    setIsOpen(false)
    setShouldRender(false)
  }

  const minimizePopup = () => {
    setIsOpen(false)
  }
  return (
    <WithGenerateMentorContext.Provider
      value={{
        openPopup,
        closePopup,
        isOpen,
      }}
    >
      {children}
      {shouldRender && (
        <GenerateMentor
          isOpen={isOpen}
          closePopup={closePopup}
          openPopup={openPopup}
          minimizePopup={minimizePopup}
          filtersData={allFilters}
        />
      )}
    </WithGenerateMentorContext.Provider>
  )
}

function useGenerateMentorContext() {
  const context = useContext(WithGenerateMentorContext)
  if (context === undefined) {
    throw new Error(
      'useGenerateMentor must be used within a HeaderVisibilityProvider',
    )
  }
  return context
}

export { useGenerateMentorContext, WithGenerateMentor }
